import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';
import Payments from '@/views/Payments.vue';
import PaymentMethod from '@/views/PaymentMethod.vue';
import PageNotFound from '@/views/PageNotFound.vue';
import NextPayment from '@/views/NextPayment.vue';
import ConfirmEmailChange from '@/views/ConfirmEmailChange.vue';
import ENV_VARS from '@/modules/env-vars.js';

Vue.use(Router);

// catch error when going to same route to prevent unhandeled NavigationDuplicated in sentry
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err);
};

function serializeRouteSearch(route, ignore) {
	var search = Object.keys(route.query)
		.filter((key) => {
			// require that a key is not a path param is not in the ignored list
			return !route.params.hasOwnProperty(key)
					&& ignore.indexOf(key) < 0;
		})
		.map((key) => {
			if (route.query.hasOwnProperty(key) && route.query[key] != null) {
				key += '=' + encodeURIComponent(route.query[key]);
			}
			return key;
		})
		.join('&');

	return (search ? '?' + search : '');
}

const handleReferrerParam = (to, from, next) => {

	const referrerClient = to.query.referrerClient;

	if (referrerClient && from.path === '/') {
		store.commit('auth/STORE_REFERRER_CLIENT', to.query.referrerClient + '?destination=' + (to.query.referrerPath || '/') + (to.query.bucket && ('&bucket=' + to.query.bucket) || ''));
		return;
	}
};

const handleEmailParam = (to, from, next) => {

	const emailToken = to.query.emailToken;

	if (emailToken) {
		next('/cea/' + emailToken);
		return;
	}

};

let coreRoutes = [
	// home route added in branding process
	{
		path: '/payments',
		name: 'payments',
		component: Payments,
		meta: {
			requiresAuth: true,
			title: 'Payments'
		}
	},
	{
		path: '/payments/method',
		name: "payments/method",
		component: PaymentMethod,
		meta: {
			hideMainHeader: true,
			requiresAuth: true,
			title: 'Payment Method'
		}
	},
	{
		path: '/payments/next',
		name: "payments/next",
		component: NextPayment,
		meta: {
			hideMainHeader: true,
			requiresAuth: true,
			title: 'Next Payment'
		}
	},
	{
		path: '/cea/:emailToken',
		name: 'cea',
		component: ConfirmEmailChange,
		meta: {
			requiresAuth: true,
			title: 'Confirm Email Change'
		}
	},
	{
		path: '/signin/:destination?',
		alias: '/login',
		name: 'signin',
		beforeEnter (to, from, next) {
			// destination can come from route param (i.e. manage subscription link) or query param (auth app)
			let dest = (typeof to.query.to === 'string') ? to.query.to :
				(typeof to.params.destination === 'string') ? to.params.destination : '';

			if (dest && dest.indexOf('?to=') >= 0) {
				// Note: this is workaround for an issue in auth's handling of client URL param
				dest = dest.slice(0, dest.indexOf('?to='));
			}

			let search = serializeRouteSearch(to, ['token', 'to']) || '';
			dest = dest + search;

			if (to.query.token) {
				// if a token is provided, re-route to home
				store.dispatch('auth/SET_REFRESH_TOKEN', to.query.token)
					.then(() => {
						// check on referrer query param
						handleReferrerParam(to, from, next);
						const params = to.query;
						delete params.token;
						// Authenticated, redirect to destination or home
						router.replace(dest);
					})
					.catch((reason) => {
						// failed to refresh token, log out
						router.replace('/signout' + (dest ? '?to=' + dest : ''));
					});
			} else {
				// otherwise route to login screen
				router.replace('/signout' + (dest ? '?to=' + dest : ''));
			}
		}
	},
	{
		path: '/signout',
		alias: '/logout',
		name: 'signout',
		beforeEnter (to) {
			var qparams = '?';
			if (to.query.reason) {
				qparams += 'reason=' + encodeURIComponent(to.query.reason) + '&';
			}
			const dest = (to.query && typeof to.query.to === 'string') ? to.query.to : '';
			qparams += 'client=' + encodeURIComponent((window.location.origin || '') + '#/signin' + (dest ? '?to=' + dest : ''));
			const authUrl = (ENV_VARS.AUTH_URL || '#/404') + qparams;

			store.dispatch('auth/LOGOUT', store.getters['auth/refreshTokenJTI'])
				.then(() => {
					// redirect to auth service
					window.location.href = authUrl;
				});
		}
	},
	{
		path: '/broken',
		name: 'broken',
		component: PageNotFound,
		meta: {
			requiresAuth: false,
			title: 'Broken'
		}
	},
	{
		path: "*",
		name: 'unknown',
		component: PageNotFound,
		meta: {
			requiresAuth: true,
			title: 'Page Not Found'
		}
	}
];

let router;

function createRouter(brandRoutes) {
	let routes = coreRoutes.concat(brandRoutes);

	router = new Router({
		routes: routes
	});

	router.beforeEach((to, from, next) => {
		// run a check email query params
		handleEmailParam(to, from, next);
		// does not apply when auth is not required
		if (!to.meta.requiresAuth || store.getters['auth/isAuthenticated']) {
			// continune on your way
			next();
			return;
		} else {
			// No entry!
			const dest = (to.params.destination === 'string') ? to.params.destination : to.fullPath || '/';
			next('/signout?reason=unauthorized&to=' + encodeURIComponent(dest));
		}
	});

	router.afterEach((to, from) => {
		const state = store.state;
		document.title = to.meta.title + ' - ' + ENV_VARS.BRAND_NAME + ' Account';
	});

	return router;
}


// export default router;

export {
	router as default,
	createRouter
};



// WEBPACK FOOTER //
// ./src/router/index.js